var path = 'api/Portal/Media'

const base64ToArrayBuff = (base64) => {
    var binaryString = window.atob(base64)
    var binaryLen = binaryString.length
    var bytes = new Uint8Array(binaryLen)
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i)
        bytes[i] = ascii
    }
    return bytes
}

function fileToDownload (response, filename) {
    var blob = new Blob([response.data], { type: response.headers['content-type'] })
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename
    link.click()
}

const downloadMedia = (contentType, base64Data, filename) => {
    var blob = new Blob([base64ToArrayBuff(base64Data)], { type: contentType })
    var fileLink = document.createElement('a')
    fileLink.href = window.URL.createObjectURL(blob)
    fileLink.download = filename
    document.body.appendChild(fileLink)
    fileLink.click()
    document.body.removeChild(fileLink)
}

const getMediaTypes = (http, moduleId) => {
    return http.get(`${path}/GetMediaTypes?moduleId=${moduleId}`)
}

const getMediaByParent = (http, parentId, moduleId) => {
    return http.get(`${path}/GetMediaByParent?parentId=${parentId}&moduleId=${moduleId}`)
}

const getMediaToDownload = (http, mediaId) => {
    return http.get(`${path}/GetMEdiaToDownload?mediaId=${mediaId}`)
}

const saveMedia = (http, formData) => {
    return http.post(`${path}/SaveMedia`, formData)
}

const isMediaTypeDriversLicense = (type) => {
    // If other Module types have drivers license types add mediaTypeId here
    return type === 1000
}

const removeMedia = (http, mediaId) => {
    return http.delete(`${path}/RemoveMedia?mediaId=${mediaId}`)
}

function uploadFile (http, formData) {
    return http.post(`/api/blobStorage/UploadFile`, formData)
}

export default {
    base64ToArrayBuff: base64ToArrayBuff,
    fileToDownload: fileToDownload,
    downloadMedia: downloadMedia,
    getMediaTypes: getMediaTypes,
    getMediaByParent: getMediaByParent,
    saveMedia: saveMedia,
    removeMedia: removeMedia,
    getMediaToDownload: getMediaToDownload,
    isMediaTypeDriversLicense: isMediaTypeDriversLicense,
    uploadFile: uploadFile
}
